@if (label) {
  <div class="mb-1 block text-xs">{{ label }}</div>
}

<div
  class="flex h-12 w-full items-center justify-between rounded-md border border-aux-gray-dark px-3 text-sm font-medium shadow-sm"
  [ngClass]="{
    'border-aux-blue ring-2 ring-aux-blue-light-200': isListOpen,
  }"
  (click)="openList()"
>
  @if (selected) {
    <span class="">{{ selected }}</span>
  } @else {
    <span class="text-gray-500">{{ placeholder || label }}</span>
  }

  <aux-icon name="ChevronDown" class="text-aux-gray-darkest" />
</div>

<div class="absolute">
  <div #trigger="cdkOverlayOrigin" cdkOverlayOrigin class="mt-2"></div>
</div>

<ng-template
  #overlay="cdkConnectedOverlay"
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isListOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'ttt'"
  [cdkConnectedOverlayMinWidth]="trigger.elementRef.nativeElement.offsetWidth"
  (detach)="closeList()"
  (backdropClick)="closeList()"
>
  <div
    class="w-full overflow-hidden rounded border border-aux-gray-dark bg-white text-sm text-aux-black shadow-lg"
  >
    <ul
      tabindex="-1"
      role="listbox"
      class="max-h-60 overflow-auto rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      (keydown)="onListKeydown($event)"
    >
      @for (option of options; track option; let index = $index) {
        <li
          class="relative cursor-default select-none py-2 pl-3 pr-16 text-gray-900"
          id="listbox-option-{{ index }}"
          [ngClass]="{
            'bg-aux-gray-light': index === highlighted,
          }"
          (mouseenter)="highlightOption(index)"
          (mouseleave)="highlighted = null"
          (click)="selectOption()"
        >
          <span
            class="block truncate font-normal"
            [ngClass]="{
              'font-medium': index === selectedIndex,
            }"
          >
            {{ option }}
          </span>

          @if (index === selectedIndex) {
            <div class="absolute inset-y-0 right-0 flex items-center pr-2">
              <svg
                class="h-4 w-4"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          }
        </li>
      }
    </ul>
  </div>
</ng-template>
